/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { QuestionConflictsControllerFindOneQueryResponse, QuestionConflictsControllerFindOnePathParams, QuestionConflictsControllerFindOneQueryParams, QuestionConflictsControllerFindOne400, QuestionConflictsControllerFindOne401, QuestionConflictsControllerFindOne403, QuestionConflictsControllerFindOne404 } from "../../models/checklistsController/QuestionConflictsControllerFindOne";

function getQuestionConflictsControllerFindOneUrl(id: QuestionConflictsControllerFindOnePathParams["id"]) {
  const res = { method: 'GET', url: `/api/v1/checklist-question-conflicts/${id}` as const }  
  return res
}

/**
 * @summary Get a specific question conflict by ID
 * {@link /api/v1/checklist-question-conflicts/:id}
 */
export async function questionConflictsControllerFindOne(id: QuestionConflictsControllerFindOnePathParams["id"], params?: QuestionConflictsControllerFindOneQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<QuestionConflictsControllerFindOneQueryResponse, ResponseErrorConfig<QuestionConflictsControllerFindOne400 | QuestionConflictsControllerFindOne401 | QuestionConflictsControllerFindOne403 | QuestionConflictsControllerFindOne404>, unknown>({ method : "GET", url : getQuestionConflictsControllerFindOneUrl(id).url.toString(), params, ... requestConfig })  
  return res.data
}